export default __webpack_public_path__ + "static/media/investments-icons.f3585fa1.svg";